import React, { useCallback, useState, useEffect } from 'react';
import PopupErrorMVP from '../PopupErrorMVP';

const ModalError = ({
  modalErrorClose,
  visible,
  message,
  techInfo,
  types,
  title,
  toLogin
}) => {
  const [vinfo, setvinfo] = useState(false);
  const [verror, setverror] = useState(false);

  useEffect(() => {
    if (visible) {
      if (types === 'info') {
        setvinfo(true);
      }
      if (types === 'error') {
        setverror(true);
      }
    } else {
      setvinfo(false);
      setverror(false);
    }
  }, [types, visible]);

  const getOnHidingError = useCallback(() => {
    if (toLogin) {
      document.location.href = '/';
    }

    modalErrorClose();
  }, [modalErrorClose, toLogin]);

  return (
    <>
      <PopupErrorMVP visible={vinfo}
                     types="info"
                     width={'600'}
                     message={message}
                     techInfo={techInfo}
                     onHiding={getOnHidingError}
                     title={title}
      />
      <PopupErrorMVP visible={verror}
                     types="error"
                     width={'600'}
                     message={message}
                     techInfo={techInfo}
                     onHiding={getOnHidingError}
                     title={title}
      />
    </>
  );
};

export default ModalError;
